import React from 'react'
import { connect } from "react-redux";
import NextStep from './NextStep'
import TipsView from '../Components/TipsView'
import AvailableMethods from '../Components/AvailableMethods'
import SuccessPage from '../Components/SuccessPage'
import MoneyInput from '../Components/MoneyInput'
import SubmitBtn from '../Components/SubmitBtn'
import TMWCon from '$Deposits/Components/TMW'


class TMW extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const { DepositNextStep, DepositSuccessPage } = this.props;

        return (
            <>
                <div className='methodsActive TMW'>
                    <TMWCon
                        TipsView={TipsView}
                        AvailableMethods={AvailableMethods}
                        MoneyInput={MoneyInput}
                        SubmitBtn={SubmitBtn}
                        NextStep={NextStep}
                        SuccessPage={SuccessPage}
                    />
                </div>
                {
                    !DepositNextStep && !DepositSuccessPage &&
                    <div className='remarks'>
                        <label>การแจ้งเตือน：</label>
                        <p>
                            QR ฝากเงินนี้ใช้สแกนได้เพียงครั้งเดียวเท่านั้น<br/>
                            รายการจะปรับภายใน 10 นาทีหลังจากโอนสำเร็จ
                        </p>
                    </div>
                }
            </>


        );
    }
}

const mapStateToProps = state => ({
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
});
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(TMW);



